"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var seo_service_1 = require("../../Services/seo.service");
var RouteSeachResults = /** @class */ (function () {
    function RouteSeachResults(service, route, advertisementClient, seo) {
        this.service = service;
        this.route = route;
        this.advertisementClient = advertisementClient;
        this.seo = seo;
        this.destroy = new rxjs_1.Subject();
    }
    RouteSeachResults.prototype.ngOnInit = function () {
        var _this = this;
        this.service.advService.searchDataStandard.isRouteSearchTrigger.next(true);
        this.route.params.pipe(operators_1.map(function (paramMap) { return paramMap; }), operators_1.takeUntil(this.destroy)).subscribe(function (routeParamPath) {
            _this.updateSearch(routeParamPath);
        });
        this.service.advService.searchInAction = true;
    };
    RouteSeachResults.prototype.updateSearch = function (params) {
        var _this = this;
        var category = params["category"];
        var city = params["city"];
        var state = params["state"];
        var type = params["type"];
        var withPicture = params["withPicture"];
        var page = params["page"] ? params["page"].replace(/\D/g, '') : 1;
        var perPage = params["per"] ? params["per"].replace(/\D/g, '') : 24;
        this.advertisementClient.getSearchParams(new WickedApiClient_1.SearchParamsRequest({ category: category, city: city, state: state, type: type, withPicture: withPicture })).toPromise().then(function (response) {
            _this.service.advService.searchDataStandard.currentSearchRule = {
                advertisementCategoryId: response.categoryId,
                casualDating: response.casualDating,
                pageNumber: page > 0 ? (page - 1) : 0,
                pageSize: parseInt(perPage),
                showExpired: false,
                showActive: true,
                regionId: response.regionId,
                subRegionId: response.subregionId,
                withPicturesOnly: response.withPicture,
                keywords: _this.service.advService.searchDataStandard.currentSearchRule.keywords
            };
            _this.service.advService.searchAction(false);
        });
    };
    RouteSeachResults.prototype.ngOnDestroy = function () {
        this.destroy.next();
        this.destroy.complete();
    };
    return RouteSeachResults;
}());
exports.RouteSeachResults = RouteSeachResults;
